<template>
    <div class="details">
        <div class="content">
            <div class="address_name">
                <div class="address_img">
                    <img src="@/assets/img/icon3.jpg" alt="">
                </div>
                <div class="header">
                    <div class="min-title">{{dataObj.storeTypeName}}</div>
                    <div class="max-title">{{dataObj.name}}</div>
                </div>
            </div>
            <div class="el-address">
                <div class="location">{{dataObj.addressInfo}}</div>
                <div class="location_btn"><a :href="href">去导航</a></div>
            </div>
            <div class="map" id="container" style="height:124px;"></div>
            <div class="phone_btn">
                <div class="phone" @click="contact()">电话咨询</div>
                <div class="wx" @click="phoneShow1=true">微信联系</div>
            </div>
        </div>
         <!--电话联系-->
        <div class="diagonIsshow" v-if="phoneShow">
            <div class="bg"></div>
            <div class="content">
                <div class="close"><img src="@/assets/img/close.png" alt="" srcset="" @click="phoneShow=false"></div>
                <div class="diagon-img"><img src="@/assets/img/phone.png" alt="" srcset=""></div>
                <div class="privacy">畅刻为保护双方隐私安全号码已做加密处理</div>
                <div class="phone">{{mobile}}</div>
                <a class="link_btn" :href="'tel:' + mobile">立即呼叫</a>
                <div class="ascription">号码归属地可能在全国任一城市，不影响接通</div>
            </div>
        </div>
        <!--微信咨询-->
        <div class="diagonIsshow" v-if="phoneShow1">
            <div class="bg"></div>
            <div class="content">
                <div class="close"><img src="@/assets/img/close.png" alt="" srcset="" @click="phoneShow1=false"></div>
                <div class="diagon-img"><img src="@/assets/img/new.png" alt="" srcset=""></div>
                <div class="privacy1">新品早知道，福利不错过</div>
                <van-field  v-model="phones" clearable placeholder="请输入您的手机号码或微信号"/>
                <a class="link_btn" @click="sendOut()">发送</a>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
import {Toast} from "vant";
export default {
    data(){
        return{
            dataObj:{},
            href:'',
            phoneShow:false,
            mobile:'',
            phones:'',
            phoneShow1:false
        }
    },
    created(){
        this.getLoadData()
    },
    mounted () {
        this.initMap()
    },
    methods:{
        getLoadData(){
            var data = {
               id: this.$route.query.id
            }
            wxRequest("/xxtx/wx/smoke/info/id", data, "post").then(res => { 
                if(res.data.code == 200){
                    this.dataObj = res.data.data
                    this.href='https://apis.map.qq.com/tools/routeplan/eword='+res.data.data.name+'&epointx='+res.data.data.longitude+'&epointy='+res.data.data.latitude+'?referer=myapp&key=UXXBZ-76EKJ-4UQFK-FXEPJ-CJB72-LUFK5'
                }else{
                    Toast(res.data.message)  
                }
            })
        },
        //发送
        sendOut(){
            var data = {
                phones: this.phones,
                id: this.dataObj.id
            }
            wxRequest("/xxtx/wx/smoke/send/phone/msg", data, "post").then(res => { 
                if(res.data.code == 200){   
                    Toast('发送成功')  
                    this.phoneShow1 = false      
                }else{
                    Toast(res.data.message)  
                }
            })
        },
        // 地图初始化函数，本例取名为init，开发者可根据实际情况定义
        initMap () {
        // 定义地图中心点坐标
            var center = new qq.maps.LatLng(this.$route.query.latitude, this.$route.query.longitude)
            // 定义map变量，调用 TMap.Map() 构造函数创建地图
            var map = new qq.maps.Map(document.getElementById('container'), {
                center: center, // 设置地图中心点坐标
                zoom: 13, // 设置地图缩放级别
                rotation: false, // 设置地图旋转角度
                zoomControl: true, //缩放控件的初始启用/停用状态。
                mapTypeControl:false //地图类型控件的初始启用/停用状态。
            })
        },
         // 联系门店
        contact(id){
            wxRequest("/xxtx/wx/smoke/search/phone/list", {id: this.dataObj.id}, "post").then(res => { 
                if(res.data.code == 200){
                    this.mobile = res.data.data
                    this.phoneShow = true                
                }else{
                    Toast(res.data.message)  
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
    .details{
        height:100%;
        width:100%;
        background: #F7F7F7;
        .content{
            margin-top:10px;
            background:#fff;
            padding:13px 14px 7px 14px;
        }
        .address_name{
            display: flex;
            padding-bottom: 20px;
            border-bottom:1px solid #EFEFEF;
            .address_img{
                width:48px;
                height:48px;
                img{
                    width:100%;
                    height:100%;
                    border-radius:6px;
                }
            }
            .header{
                margin-left: 10px;
                .min-title{
                    border:1px solid #CD6262;
                    background: #FFF1F1;
                    border-radius:3px;
                    font-size:12px;
                    color:#CD6262;
                    padding:6px 8px;
                    display: inline-block;
                }
                .max-title{
                    font-size:16px;
                    color:#2D2D2D;
                    margin-top: 7px;
                }
            }
        }
        .el-address{
            margin-top: 19px;
            display: flex;
            margin-bottom:14px;
            .location{
                width:70%;
                font-size:14px ;
                line-height:20px;
                color: #767676;
            }
            .location_btn{
                text-align: right;
                font-size:16px;
                cursor: pointer;
                width:30%;
                line-height:20px;
                a{
                    color:#007AFF;
                }
            }
        }
        .map{
            height: 124px !important;
            img,div{
                width:100%;
                height:100%;
            }
        }
        .phone_btn{
            margin-top:36px;
             display: flex;
            .phone{
                width:48%;
                text-align: center;
                height:44px;
                line-height: 44px;
                color:#2D2D2D;
                font-size:14px;
                border: 1px solid #C9C9C9;
                cursor: pointer;
                margin-right: 11px;
            }
            .wx{
                width:48%;
                text-align: center;
                height:44px;
                line-height: 44px;
                background: #007AFF;
                color:#fff;
                font-size:14px;
                border: 1px solid #007AFF;
                cursor: pointer;
            }
        }
        .diagonIsshow{
            position:fixed;
            top:0;
            left: 0;
            width:100%;
            height:100%;
            .bg{
                background:rgba(0,0,0,.35);
                position:fixed;
                top:0;
                left: 0;
                width:100%;
                height:100%;
            }
            .content{
                width:75%;
                background:#fff;
                position: absolute;
                height:300px;
                left:0;
                right:0;
                top:0;
                bottom:0;
                margin: auto;
                .close{
                    width:100%;
                    height:22px;
                    text-align: right;
                    img{
                        width:22px;
                        height:100%;
                    }
                }
                .diagon-img{
                    text-align: center;
                    height:87px;
                    width: 100%;
                    img{
                        height:100%;
                        widows:78px;
                    }
                }
                .privacy{
                    color:#979797;
                    font-size:14px;
                    width:156px;
                    line-height:20px;
                    margin: 0 auto 18px;
                    text-align: center;
                }
                .privacy1{
                    color: #353648;
                    font-size:18px;
                    text-align: center;
                    font-weight:bold;
                }
                .van-cell{
                    margin-top: 18px;
                    border-bottom: 1px solid #DDDEDD;
                    margin-bottom: 50px;
                    padding-bottom: 0;
                    ::v-deep .van-field__control{
                        text-align: center;
                        font-size: 12px;
                        height: 32px;
                        line-height: 32px;
                    }
                }
                .phone{
                    color:#353648;
                    font-size:26px;
                    text-align: center;
                    margin-bottom: 33px;
                }
                .link_btn{
                    background:#007AFF;
                    color:#fff;
                    height:50px;
                    line-height:50px;
                    border-radius:4px;
                    width:100%;
                    font-size:16px;
                    display: block;
                    text-align: center;
                }
                .ascription{
                    color:#C2C2C2;
                    font-size:12px;
                    margin-top:8px;
                    text-align: center;
                }
            }
        }
    }
</style>